<template>
  <div>
    <!-- Filtros -->
    <activity-filters :projectId="project.id"
      @filters-updated="filtersUpdated"
      ref="filtersRef"/>

    <div class="flex w-full flex-wrap flex-col sm:flex-row relative">
      <!-- Filtro por subactividades -->
      <div class="flex sm:w-1/2">
        <v-switch
          :disabled="isLoadingTable"
          :focusable="! isLoadingTable"
          :label="$t('filter_by_subactivities')"
          :color="filterSubactivities ? 'green' : 'red'"
          :value="filterSubactivities"
          v-on:checked="checkFilterSubactivities"
          style="margin-left: 5px"
        />
        <v-switch
          :disabled="isLoadingTable"
          :focusable="! isLoadingTable"
          :label="$t('activities_in_planning')"
          :color="filterInPlanningLocal ? 'green' : 'red'"
          :value="filterInPlanningLocal"
          v-on:checked="checkFilterInPlanningLocal"
          style="margin-left: 5px"
        />
        <v-switch
          :disabled="isLoadingTable"
          :focusable="! isLoadingTable"
          :label="$t('activities_out_planning')"
          :color="filterOutPlanningLocal ? 'green' : 'red'"
          :value="filterOutPlanningLocal"
          v-on:checked="checkFilterOutPlanningLocal"
          style="margin-left: 5px"
        />
        <b-tooltip v-if="project.has_westop"
          :label="project.has_westop? 'We Stop project' : 'We Stop Activity' " position="is-top">
            <img :src="asset('public/westop-tke.png')" alt="Expanded Image" width="50" class="p-4" />
        </b-tooltip>
      </div>
      <!-- Botones, sólo Jefes de departamento -->
      <div class="flex w-full sm:w-1/2 justify-end items-center gap-2 flex-wrap">
        <button
          v-if="!project.can_collaborate && isWeeklyWorkMode"
          type="button"
          class="inline-flex items-center gap-2 px-3 py-1.5 rounded border-2 border-blue text-blue bg-white hover:bg-blue-lightest text-sm font-medium shrink-0"
          @click="goToWeeklyPlanningView"
        >
          <b-icon pack="fas" icon="table-cells" size="is-small" />
          <span>{{ $t('weekly_planning_view') }}</span>
        </button>
        <quick-button-menu class="flex-1 min-w-0" :buttons="quickButtonMenu()">
          <template v-if="project.can_admin || true"> <!-- always show -->
            <project-report v-if="!isLoadingTable && !project.can_collaborate && !isCanalYII" :filters="this.generatedFilters" :openWithButton="false"/>
            <project-report-excel v-if="showExcelReport && !project.can_collaborate" :openWithButton="false"/>
          </template>
          <!-- Botón Lotes canal plan sanea exportar EXCEL proyecto -->
          <project-report-sanea v-if="showSaneaReport"/>
          <!-- Botón Lotes canal plan red exportar CSV proyecto -->
          <project-report-lotes v-if="showLotesReport" :openWithButton="false"/>
        </quick-button-menu>
      </div>
    </div>


    <div class="text-sm panel">

      <div class="mb-3">
        <multiselect v-model="columnsSelected"
          :options="filteredColumns"
          :multiple="true"
          :deselect-label="$t('multiselect_deselect_label')"
          :select-label="$t('multiselect_select_label')"
          :selected-label="$t('multiselect_selected_label')"
          :show-labels="true"
          :hide-selected="false"
          :limit-text="count => `y ${count} más`"
          label="title"
          track-by="key"
          :close-on-select="true" :clear-on-select="false" :preserve-search="true"
          :max-height="150"
          :allow-empty="true"
          :limit="limitShowColumnsSelect"
          @select="_HandleSelectItem"
          @remove="_HandleRemoveItem">
        </multiselect>
      </div>


      <template>
        <!-- Contador de resultados -->
        <div class="flex w-full flex-col mb-3">
          <div class="flex flex-row-reverse">
            <div>
              <b-select v-model="perPage" @input="filtersUpdated">
                <option value="10">{{ $t('per_page', {amount: 10}) }}</option>
                <option value="25">{{ $t('per_page', {amount: 25}) }}</option>
                <option value="50">{{ $t('per_page', {amount: 50}) }}</option>
              </b-select>
            </div>
          </div>
          <div v-if="total" class="w-full text-right">
            <b>{{ $t('count_results') }}: {{ total }}</b>
          </div>
        </div>

        <b-table
          :data="list"
          :loading="isLoadingTable"

          paginated
          backend-pagination
          :per-page="perPage"
          :current-page.sync="currentPage"
          :total="total"
          @page-change="onPageChange"

          backend-sorting
          :default-sort="orderField"
          :default-sort-direction="orderDir"
          @sort="onSort"

          detailed
          detail-key="id"
          icon-pack="fas"
          :has-detailed-visible="displaySubactivitiesOrAssignments"
          :opened-detailed="mainOpenedDetailedIds"
          @details-open="openDetails"
          @details-close="onMainDetailsClose"

          class="text-xs border-blue-lighter"
          bordered
          narrowed
          striped
          :row-class="getRowClass"

          :sticky-header="stickyHeader"
          :mobile-cards="false"
          @select="handleRowSelected"
        >

          <template slot="empty">
            <div v-if="! isLoadingTable" class="m-4 text-lg text-dark-grey">
              <span>{{ $t('empty_activities_table_msg') }}</span>
            </div>
          </template>

          <template>

            <b-table-column field="star" cell-class="w-8 vertical-center" centered sortable>
              <template v-slot:header="">
                <i class="fas fa-star"></i>
              </template>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div v-if="!activities.row.favorite" @click="addFavorite(activities.row.id, activities.index)"
                      class="cursor-pointer">
                    <b-icon icon="star" pack="fas" size="is-small" class="text-grey"/>
                  </div>

                  <div v-if="activities.row.favorite" @click="deleteFavorite(activities.row.id, activities.index)"
                      class="cursor-pointer">
                    <b-icon icon="star" pack="fas" size="is-small" class="text-yellow-dark"/>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="in_planning" label="P" :visible="columns['in_planning'].visible"
                            cell-class="w-8 vertical-center" centered sortable>
              <template v-slot:header="">
                <i class="fas fa-road"></i>
              </template>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div v-if="activities.row.in_planning">
                    <b-tooltip :label="$t('in_planning')">
                      <b-icon icon="road" pack="fas" size="is-small" class="text-green"/>
                    </b-tooltip>
                  </div>
                  <div v-if="!activities.row.in_planning">
                    <b-tooltip :label="$t('out_planning')">
                      <b-icon icon="road" pack="fas" size="is-small" class="text-grey"/>
                    </b-tooltip>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="mobile" cell-class="w-8 vertical-center" centered sortable>
              <template v-slot:header="">
                <i class="fas fa-mobile-alt"></i>
              </template>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div v-if="!activities.row.show_on_devices" @click="showOnDevice(activities.row.id, activities.index)"
                      :class="{'cursor-pointer': project.can_admin}">
                    <b-icon icon="mobile-alt" pack="fas" size="is-small" class="text-grey"/>
                  </div>

                  <div v-if="activities.row.show_on_devices" @click="hideOnDevice(activities.row.id, activities.index)"
                      class="{'cursor-pointer': project.can_admin}">
                    <b-icon icon="mobile-alt" pack="fas" size="is-small" class="text-green"/>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="group" cell-class="w-8 vertical-center" centered sortable>
              <template v-slot:header="">
                <i class="fas fa-layer-group"></i>
              </template>
              <template v-slot="activities">
                <div v-if="activities.row.group"
                  class="relative inline-flex items-center justify-center cursor-pointer w-7 h-7 overflow-hidd rounded-full"
                    :style="{'background-color' : colorGroup(activities.row.group) }">
                  <b-tooltip :label="activities.row.full_path"
                    position="is-right"
                    >
                    <span class="font-medium text-white">{{ nameGroup(activities.row.group) }}</span>
                    <template v-slot:content>
                      <div><b>Grupo: </b> {{ activities.row.group.name }}</div>
                    </template>
                  </b-tooltip>
                </div>
                <!-- <div v-else
                  class="relative inline-flex items-center justify-center w-7 h-7 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
                  <b-tooltip :label="$t('without_group')"
                    position="is-right">
                    <span class="font-medium text-gray-600 dark:text-gray-300">SG</span>
                  </b-tooltip>
                </div> -->
              </template>
            </b-table-column>

            <b-table-column field="user" cell-class="w-8 vertical-center" label="" :visible="columns['user'].visible"
                            centered>
              <template v-slot:header="">
                <i class="fas fa-user"></i>
              </template>
              <template v-slot="activities">
                <div class="relative inline-flex items-center justify-center cursor-pointer w-7 h-7 overflow-hidd rounded-full">
                  <b-tooltip v-if="activities.row.manager && activities.row.manager.user_id"
                            :label="activities.row.manager.fullname">
                    <img
                      :src="activities.row.manager.avatar"
                      class="w-7 h-7 overflow-hidden rounded-full">
                  </b-tooltip>
                </div>
              </template>
            </b-table-column>

            <b-table-column field="planning_code" :visible="columns['planning_code'].visible" :label="$t('code')"
                            sortable cell-class="vertical-center" v-slot="activities" :sticky="true">
              <div :class="activities.row.without_access === 1 ? '' : 'cursor-pointer'" 
                   @click="activities.row.without_access === 1 ? null : onRowClicked(activities.row.is_subactivity, activities.row.parent_id, activities.row.id)">
                {{ activities.row.planning_code }}
              </div>
            </b-table-column>

            <b-table-column field="name" :visible="columns['name'].visible" :label="$t('name')" sortable
                            cell-class="vertical-center" v-slot="activities">
                <div :class="activities.row.without_access === 1 ? '' : 'cursor-pointer'"
                     @click="activities.row.without_access === 1 ? null : onRowClicked(activities.row.is_subactivity, activities.row.parent_id, activities.row.id)">
                  <!-- <activity-time-status :date="activities.row.current_end_date" class="mr-2"

                                        v-if="activities.row.status != 4 && activities.row.status != 6"/> -->
                  <b-tooltip v-if="activities.row.critical_path != null" position="is-right"
                             :label="$t('critical_path')">
                    <b-icon class="fa is-small fa-project-diagram" style="color:#e3342f"></b-icon>
                  </b-tooltip>
                  <template v-if="activities.row.parent !== null">
                    <b-tooltip :label="activities.row.parent !== null ? activities.row.parent.name : ''" position="is-top"
                          multilined>
                    {{ activities.row.name }}
                    </b-tooltip>
                  </template>
                  <template v-else>
                    {{ activities.row.name }}
                  </template>
                </div>
            </b-table-column>

            <b-table-column field="location" :visible="columns['location'].visible" :label="$t('location')"
                            sortable cell-class="vertical-center" v-slot="activities">
              <div>
                <span v-if="activities.row.location">
                  {{ activities.row.location.name }}
                </span>
              </div>
            </b-table-column>

            <b-table-column field="type" :visible="columns['type'].visible" :label="$t('type')"
                            sortable cell-class="vertical-center" v-slot="activities">
              <div>
                <template v-if="activities.row.without_access !== 1">
                  <span v-if="activities.row.activityType">
                    {{ activities.row.activityType.name }}
                  </span>
                </template>
                <template v-else></template>
              </div>
            </b-table-column>

            <b-table-column v-if="project.can_progress" field="original_progress" :label="$t(columns['original_progress'].title)" :visible="columns['original_progress'].visible"
                            cell-class="w-32 vertical-center" centered sortable v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <progress-bar
                  :step="activities.row.original_progress || 0"
                  color="blue-light" :decimals="displayDecimals"
                  class="w-full"
                />
              </template>
              <template v-else></template>
            </b-table-column>

            <b-table-column v-if="project.can_progress" field="latest_progress" :label="$t(columns['latest_progress'].title)" :visible="columns['latest_progress'].visible"
                            cell-class="w-32 vertical-center" centered sortable v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <progress-bar
                  :step="activities.row.latest_progress || 0"
                  color="blue-light" :decimals="displayDecimals"
                  class="w-full"
                />
              </template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="progress" :label="progressLabel" :visible="columns['progress'].visible"
                            cell-class="w-32 vertical-center" centered sortable v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <progress-bar
                  :step="parseFloat(activities.row.progress) || 0"
                  color="blue-light" :decimals="displayDecimals"
                  class="w-full"
                />
              </template>
              <template v-else></template>
            </b-table-column>

            <b-table-column v-if="project.can_progress" field="progress_actual" :label="$t('actual_progress')" :visible="columns['actual_progress'].visible"
                            cell-class="w-32 vertical-center" centered sortable v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <progress-bar
                  :step="parseFloat(activities.row.progress_actual) || 0"
                  color="blue-light" :decimals="displayDecimals"
                  class="w-full"
                />
              </template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="current_start_date" :label="$t('planned_start')"
                            :visible="columns['current_start_date'].visible" cell-class="w-25 vertical-center" sortable
                            centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">{{ activities.row.current_start_date }}</template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="current_end_date" :label="$t('planned_end')" :visible="columns['current_end_date'].visible"
                            cell-class="w-25 vertical-center" sortable centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">{{ activities.row.current_end_date }}</template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="gantt_expected_start_date" :label="$t('expected_start_date')"
                            :visible="columns['gantt_expected_start_date'].visible" cell-class="w-25 vertical-center" sortable
                            centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">{{ activities.row.gantt_expected_start_date }}</template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="gantt_expected_end_date" :label="$t('expected_end_date')"
                            :visible="columns['gantt_expected_end_date'].visible" cell-class="w-25 vertical-center" sortable
                            centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">{{ activities.row.gantt_expected_end_date }}</template>
              <template v-else></template>
            </b-table-column>

            <!-- gantt_real_start_date -->
            <b-table-column field="gantt_real_start_date" :label="$t('actual_start')"
                            :visible="columns['gantt_real_start_date'].visible" cell-class="w-25 vertical-center" sortable
                            centered v-slot="activities">
                <template v-if="activities.row.without_access !== 1">{{ activities.row.gantt_real_start_date }}</template>
                <template v-else></template>
            </b-table-column>
            <b-table-column field="gantt_real_end_date" :label="$t('actual_end')"
                            :visible="columns['gantt_real_end_date'].visible" cell-class="w-25 vertical-center" sortable
                            centered v-slot="activities">
                <template v-if="activities.row.without_access !== 1">{{ activities.row.gantt_real_end_date }}</template>
                <template v-else></template>
            </b-table-column>

            <b-table-column field="status" :label="$t('status')" cell-class="w-32 vertical-center"
                            :visible="columns['status'].visible" sortable centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <div class="relative  overflow-hidd">
                  <activity-status-label :status=" activities.row.status == 7 && ignore_delayed_state ? 1 : activities.row.status "
                    fontSize="0.65"
                    class="w-full"
                    style="vertical-align: middle"/>
                </div>
              </template>
              <template v-else></template>
            </b-table-column>
            <b-table-column field="status" :label="$t('actual_status')" cell-class="w-32 vertical-center"
                            :visible="columns['actual_status'].visible" sortable centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">
                <div class="relative  overflow-hidd">
                  <activity-status-label :status=" activities.row.status_actual == 7 && ignore_delayed_state ? 1 : activities.row.status_actual "
                    fontSize="0.65"
                    class="w-full"
                    style="vertical-align: middle"/>
                </div>
              </template>
              <template v-else></template>
            </b-table-column>
                                        
            <b-table-column field="task_status" 
            :visible="company && company.configs && company.configs.subtasks == true && columns['task_status'].visible"
              
              cell-class="w-32 vertical-center" centered sortable>
              <template v-slot:header="">
                {{ $t('task_status') }}
              </template>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div v-if="getIssueIcon(activities.row.task_status) != null"
                    class="flex text-center align-middle cursor-pointer justify-center " >
                    <b-tooltip class="text-center"
                      :label="$t('issues')" position="is-right">
                      <!-- si es diferente de hand mostramos icon  -->
                      <b-icon v-if="getIssueIcon(activities.row.task_status).icon != 'hand'"
                      :icon="getIssueIcon(activities.row.task_status).icon" pack="fas" size="is-small" :class="getIssueIcon(activities.row.task_status).color"></b-icon>
                      <!-- si es hand usamos la imagen -->
                      <img v-else :src="asset('public/westop-tke.png')" alt="Expanded Image" width="50" class="p-2" />
                    </b-tooltip>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>
            <b-table-column v-if="hasStatusList()" field="status" :label="$t('custom_status')"
                            cell-class="w-32 vertical-center"
                            :visible="columns['status_id'].visible"
                            sortable centered v-slot="activities">
              <template v-if="activities.row.without_access !== 1">{{ getStatusIdName(activities.row.status_id) }}</template>
              <template v-else></template>
            </b-table-column>

            <b-table-column field="actions" label="" cell-class="w-12 vertical-center" centered>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div @click="goToPrelations(activities.row)">
                    <b-tooltip :label="$t('see_links')" position="is-top">
                      <b-icon icon="shuffle" pack="fas" size="is-small" class="mr-1" v-bind:class="[hasPrelations(activities.row) ? 'text-blue' : 'text-grey-light']"/>
                    </b-tooltip>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="notifications" :label="$t('notifications')"
                            :visible="columns['notifications'].visible" cell-class="w-12 vertical-center"
                            sortable centered>
              <template v-slot:header="">
                <i class="fas fa-bell"></i>
              </template>
              <template v-slot="activities">
                <entity-notifications
                  v-if="activities.row.without_access !== 1"
                  :entityId="activities.row.id"
                  entityType="activity"
                  :mentions="activities.row.notifications.mentions"
                  :change_status="activities.row.notifications.change_status"
                  :comments="activities.row.notifications.comments"
                  :documents="activities.row.notifications.documents"
                  :assignments_warnings="activities.row.notifications.assignments_warnings"
                  :enabledChangedStatus="true"
                  :enabledActualDates="enabledActualDates"
                  :actual_dates_required="verifyRequiredActualDates(activities.row)"
                />
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="context_menu" label="" cell-class="w-8 vertical-center" centered>
              <template v-slot="activities">
                <template v-if="activities.row.without_access !== 1">
                  <div class="text-center cursor-pointer" @click.stop>
                    <b-dropdown aria-role="list" position="is-bottom-left">
                      <template #trigger="{ active }">
                        <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                      </template>
                      <b-dropdown-item
                        v-if="canManageActivity(activities.row)"
                        aria-role="listitem"
                        @click="onEditActivityClicked(activities.row)"
                      >
                        <span class="text-xs">{{ $t('edit') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="canManageActivity(activities.row)"
                        aria-role="listitem"
                        @click="onCreateSubactivity(activities.row)"
                      >
                        <span class="text-xs">{{ $t('add_subactivity') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="canCreateAssignments(activities.row)"
                        aria-role="listitem"
                        :disabled="!canCreateTaskOrResourceFromList(activities.row)"
                        @click="onCreateAssignments(activities.row, 'task')"
                      >
                        <span class="text-xs">{{ $t('add_measurement_title') }} — {{ $t('task') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="canCreateAssignments(activities.row)"
                        aria-role="listitem"
                        :disabled="!canCreateTaskOrResourceFromList(activities.row)"
                        @click="onCreateAssignments(activities.row, 'resource')"
                      >
                        <span class="text-xs">{{ $t('add_measurement_title') }} — {{ $t('resource') }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
                <template v-else></template>
              </template>
            </b-table-column>

            <b-table-column field="id" numeric cell-class="is-hidden" :visible="false" v-slot="activities">
              {{ activities.row.id }}
            </b-table-column>

          </template>

          <template slot="detail" slot-scope="activities">

            <!--Mediciones -->
            <div class="mb-1" v-if="displayAssignments(activities.row)">
              <b-collapse
                class="card"
                animation="slide"
                aria-id="contentIdForA11y3"
                :open="false"
                @open="onMeasurementsCollapseOpen(activities.row)">
                <template #trigger="props">
                  <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3"
                    :aria-expanded="props.open">
                    <div class="card-header-title">
                      <h4>
                        <b>{{ $t('measurements') }}</b>
                      </h4>
                    </div>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'caret-down' : 'caret-up'">
                        </b-icon>
                    </a>
                  </div>
                </template>

                <div class="card-content p-0">
                  <div class="content">
                    <assignment-table :ref="'assignments_' + activities.row.id"
                      :list="activities.row.assignments"
                      :entityId="activities.row.id"
                      :activityName="activities.row.name"
                      :subactivityId="activities.row.is_subactivity ? activities.row.id : null"
                      :activityId="activities.row.is_subactivity ? activities.row.parent_id : activities.row.id"
                      :entityBlockedAssignments="activities.row.blocked_assignments == 1"
                      :canManageCertifiers="!!activities.row.is_project_certifier"
                      :canRecordActualprogress="!!activities.row.is_project_progress"
                      :currentStartDate="activities.row.current_start_date"
                      :currentEndDate="activities.row.current_end_date"
                      :lockedTasks="!!(project && project.has_westop) || (activities.row.task_status == 0) || (activities.row.task_status == 5) || (activities.row.parent_task_status == 5)"
                      :canManage="!!activities.row.is_project_manager"
                      :apiProject="apiProject"
                      @reload="reloadActivities"/>
                  </div>
                </div>
                <!-- <footer class="card-footer">
                    <a class="card-footer-item">Save</a>
                    <a class="card-footer-item">Edit</a>
                    <a class="card-footer-item">Delete</a>
                </footer> -->
              </b-collapse>
            </div>

            <!-- Subactividades -->
            <div v-if="displaySubactivities(activities.row)">
              <b-collapse
                class="card"
                animation="slide"
                aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div
                        class="card-header"
                        role="button"
                        aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">

                        <div class="card-header-title">
                          <h4>
                            <b>{{ getVisibleSubactivitiesCount(activities.row) }} {{
                                getVisibleSubactivitiesCount(activities.row) > 1 ?
                                  $t('subactivities') : $t('subactivity')
                              }}</b>
                          </h4>
                        </div>

                        <a class="card-header-icon">
                            <b-icon icon-pack="fas"
                                :icon="props.open ? 'caret-down' : 'caret-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content p-0">
                    <div class="content">

                      <template>
                        <b-table
                          ref="subactivities"
                          :data="getSubactivities(activities.row)"
                          default-sort="planning_code"
                          default-sort-direction="asc"
                          bordered
                          class="text-xs border-blue-lighter bg-grey-lighter subactivities"
                          narrowed

                          detailed
                          detail-key="id"
                          icon-pack="fas"
                          :has-detailed-visible="displaySubactivitiesOrAssignments"

                          :opened-detailed="openedSubactivitiesId === activities.row.id ? subactivityDetailedIds : []"
                          @details-open="onNestedDetailsOpen"
                          @details-close="onNestedDetailsClose"

                          :row-class="getSubRowClass"
                          @select="handleRowSelected">

                          <template>

                            <b-table-column field="star" cell-class="w-8 vertical-center" centered sortable
                                            :custom-sort="sortByFavorite">
                              <template v-slot:header="">
                                <i class="fas fa-sm fa-star"></i>
                              </template>
                              <template v-slot="subactivities_info">
                                <div v-if="!subactivities_info.row.favorite"
                                    @click="addFavorite(subactivities_info.row.id, subactivities_info.index, true)"
                                    class="cursor-pointer">
                                  <b-icon icon="star" pack="fas" size="is-small" class="text-grey"/>
                                </div>
                                <div v-if="subactivities_info.row.favorite"
                                    @click="deleteFavorite(subactivities_info.row.id, subactivities_info.index, true)"
                                    class="cursor-pointer">
                                  <b-icon icon="star" pack="fas" size="is-small" class="text-yellow-dark"/>
                                </div>
                              </template>
                            </b-table-column>

                            <b-table-column field="in_planning" :visible="columns['in_planning'].visible" label="P"
                                            cell-class="w-8 vertical-center" centered sortable >
                              <template v-slot:header="">
                                <i class="fas fa-sm fa-road"></i>
                              </template>
                              <template v-slot="subactivities_info">
                                <div v-if="subactivities_info.row.in_planning">
                                  <b-tooltip :label="$t('in_planning')">
                                    <b-icon icon="road" pack="fas" size="is-small" class="text-green"/>
                                  </b-tooltip>
                                </div>
                                <div v-if="!subactivities_info.row.in_planning">
                                  <b-tooltip :label="$t('out_planning')">
                                    <b-icon icon="road" pack="fas" size="is-small" class="text-grey"/>
                                  </b-tooltip>
                                </div>
                              </template>
                            </b-table-column>

                            <b-table-column field="mobile" cell-class="w-8 vertical-center" centered sortable
                                            :custom-sort="sortByShowOnDevices">
                              <template v-slot:header="">
                                <i class="fas fa-sm fa-mobile-alt"></i>
                              </template>
                              <template v-slot="subactivities_info">
                                <div v-if="!subactivities_info.row.show_on_devices"
                                    @click="showOnDevice(subactivities_info.row.id, subactivities_info.index, true)"
                                    :class="{'cursor-pointer': project.can_admin}">
                                  <b-icon icon="mobile-alt" pack="fas" size="is-small" class="text-grey"/>
                                </div>
                                <div v-if="subactivities_info.row.show_on_devices"
                                    @click="hideOnDevice(subactivities_info.row.id, subactivities_info.index, true)"
                                    :class="{'cursor-pointer': project.can_admin}">
                                  <b-icon icon="mobile-alt" pack="fas" size="is-small" class="text-green"/>
                                </div>
                              </template>
                            </b-table-column>

                            <b-table-column field="user" :visible="columns['user'].visible" label=""
                                            cell-class="w-12 vertical-center" centered >
                              <template v-slot:header="">
                                <i class="fa fa-sm fa-user"></i>
                              </template>
                              <template v-slot="subactivities_info">
                                <b-tooltip v-if="subactivities_info.row.manager" :label="subactivities_info.row.manager.fullname">
                                  <img :src="subactivities_info.row.manager.avatar"
                                      class="w-6 h-6 overflow-hidden rounded-full reduce">
                                </b-tooltip>
                              </template>
                            </b-table-column>

                            <b-table-column field="planning_code" :visible="columns['planning_code'].visible"
                                        sortable :custom-sort="sortByPlanningCode" cell-class="vertical-center">
                              <template v-slot:header="">
                                {{ $t('code') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <div :class="subactivities_info.row.access ? 'cursor-pointer' : ''"
                                    @click="onRowClicked(subactivities_info.row.is_subactivity, subactivities_info.row.parent_id, subactivities_info.row.id, subactivities_info.row.access)"
                                  >{{ subactivities_info.row.planning_code }}</div>
                              </template>
                            </b-table-column>

                            <b-table-column field="name" :visible="columns['name'].visible"
                                            cell-class="vertical-center" sortable>
                              <template v-slot:header="">
                                {{ $t('name') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <div :class="subactivities_info.row.access ? 'cursor-pointer' : ''"
                                    @click="onRowClicked(subactivities_info.row.is_subactivity, subactivities_info.row.parent_id, subactivities_info.row.id, subactivities_info.row.access)">
                                  <!-- <activity-time-status :date="subactivities_info.row.current_end_date" class="mr-2 reduce"

                                                        v-if="![4, 6].includes(subactivities_info.row.status)"/> -->
                                  <b-tooltip v-if="subactivities_info.row.critical_path != null" position="is-right"
                                    :label="$t('critical_path')">
                                    <b-icon class="fa is-small fa-project-diagram" style="color:#e3342f"></b-icon>
                                  </b-tooltip>
                                  {{ subactivities_info.row.name }}
                                </div>
                              </template>
                            </b-table-column>

                            <b-table-column field="location" :visible="columns['location'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('location') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <span v-if="subactivities_info.row.location">
                                  {{subactivities_info.row.location.name }}
                                </span>
                              </template>
                            </b-table-column>

                            <b-table-column field="type" :visible="columns['type'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('type') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <span v-if="subactivities_info.row.activityType">
                                  {{subactivities_info.row.activityType.name }}
                                </span>
                              </template>
                            </b-table-column>

                            <b-table-column v-if="project.can_progress"
                            field="original_progress" :visible="columns['original_progress'].visible"
                                            cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t(columns['original_progress'].title) }}
                              </template>
                              <template v-slot="subactivities_info">
                                <progress-bar
                                  :step="subactivities_info.row.original_progress || 0"
                                  color="blue-light" :decimals="displayDecimals"
                                  class="w-full"
                                />
                              </template>
                            </b-table-column>

                            <b-table-column v-if="project.can_progress"
                            field="latest_progress" :visible="columns['latest_progress'].visible"
                                            cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t(columns['latest_progress'].title) }}
                              </template>
                              <template v-slot="subactivities_info">
                                <progress-bar
                                  :step="subactivities_info.row.latest_progress || 0"
                                  color="blue-light" :decimals="displayDecimals"
                                  class="w-full"
                                />
                              </template>
                            </b-table-column>

                            <b-table-column field="progress" :visible="columns['progress'].visible"
                                            cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ progressLabel }}
                              </template>
                              <template v-slot="subactivities_info">
                                <progress-bar
                                  :step="parseFloat(subactivities_info.row.progress) || 0"
                                  color="blue-light" :decimals="displayDecimals"
                                  class="w-full"
                                />
                              </template>
                            </b-table-column>

                            <b-table-column v-if="project.can_progress"
                            field="actual_progress" :visible="columns['actual_progress'].visible"
                                            cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('actual_progress') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <progress-bar
                                  :step="parseFloat(subactivities_info.row.progress_actual) || 0"
                                  color="blue-light" :decimals="displayDecimals"
                                  class="w-full"
                                />
                              </template>
                            </b-table-column>

                            <b-table-column field="current_start_date" :visible="columns['current_start_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('planned_start') }}
                              </template>
                              <template v-slot="subactivities_info">
                              {{ subactivities_info.row.current_start_date }}
                              </template>
                            </b-table-column>

                            <b-table-column field="current_end_date" :visible="columns['current_end_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('planned_end') }}
                              </template>
                              <template v-slot="subactivities_info">
                                {{ subactivities_info.row.current_end_date }}
                              </template>
                            </b-table-column>

                            <b-table-column field="gantt_expected_start_date" :visible="columns['gantt_expected_start_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('expected_start_date') }}
                              </template>
                              <template v-slot="subactivities_info">
                                {{ subactivities_info.row.gantt_expected_start_date }}
                              </template>
                            </b-table-column>

                            <b-table-column field="gantt_expected_end_date" :visible="columns['gantt_expected_end_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('expected_end_date') }}
                              </template>
                              <template v-slot="subactivities_info">
                                {{ subactivities_info.row.gantt_expected_end_date }}
                              </template>
                            </b-table-column>

                            <b-table-column field="gantt_real_start_date" :visible="columns['gantt_real_start_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('actual_start') }}
                              </template>
                              <template v-slot="subactivities_info">
                                {{ subactivities_info.row.gantt_real_start_date }}
                              </template>
                            </b-table-column>
                            <b-table-column field="gantt_real_end_date" :visible="columns['gantt_real_end_date'].visible"
                                            cell-class="w-25 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('actual_end') }}
                              </template>
                              <template v-slot="subactivities_info">
                                {{ subactivities_info.row.gantt_real_end_date }}
                              </template>
                            </b-table-column>

                            <b-table-column field="status" :visible="columns['status'].visible"
                                            cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('status') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <activity-status-label
                                  :status=" subactivities_info.row.status == 7 && ignore_delayed_state ? 1 : subactivities_info.row.status"
                                  fontSize="0.55"
                                  class="w-full"/>
                              </template>
                            </b-table-column>
                            <b-table-column field="status_actual" :visible="columns['actual_status'].visible"
                                            cell-class="w-36 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('actual_status') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <activity-status-label
                                  :status=" subactivities_info.row.status_actual == 7 && ignore_delayed_state ? 1 : subactivities_info.row.status_actual"
                                  fontSize="0.55"
                                  class="w-full"/>
                              </template>
                            </b-table-column>
                            
                            <b-table-column field="task_status" :visible="company && company.configs && company.configs.subtasks == true && columns['task_status'].visible"
                             
                              cell-class="w-32 vertical-center" centered sortable>
                              <template v-slot:header="">
                                {{ $t('task_status') }}
                              </template>
                              <template v-slot="subactivities_info">
                                <div v-if="getIssueIcon(subactivities_info.row.task_status) != null"
                                  class="flex text-center align-middle cursor-pointer justify-center " >
                                  <b-tooltip class="text-center"
                                    :label="$t('issues')" position="is-right">
                                    <b-icon 
                                      v-if="getIssueIcon(subactivities_info.row.task_status).icon != 'hand'"
                                    :icon="getIssueIcon(subactivities_info.row.task_status).icon" pack="fas" size="is-small"
                                    :class="getIssueIcon(subactivities_info.row.task_status).color"/>
                                    <img v-else :src="asset('public/westop-tke.png')" alt="Expanded Image" width="45" class="p-2" />
                                  </b-tooltip>
                                </div>
                              </template>
                            </b-table-column>
                            <b-table-column field="actions" label="" cell-class="w-12 vertical-center" centered>
                              <template v-slot="subactivities_info">
                                <div @click="goToPrelations(subactivities_info.row)">
                                  <b-tooltip :label="'Ver Prelaciones'" position="is-top">
                                    <b-icon icon="shuffle" pack="fas" size="is-small" class="mr-1" v-bind:class="[hasPrelations(subactivities_info.row) ? 'text-blue' : 'text-grey-light']"/>
                                  </b-tooltip>
                                </div>
                              </template>
                            </b-table-column>

                            <b-table-column field="notifications" :visible="columns['notifications'].visible"
                                            cell-class="w-24 vertical-center" centered sortable :custom-sort="sortByNotifications">
                              <template v-slot:header="">
                                <i class="fa fa-bell"></i>
                              </template>
                              <template v-slot="subactivities_info">
                                <entity-notifications
                                  :entityId="subactivities_info.row.id"
                                  entityType="activity"
                                  :mentions="subactivities_info.row.notifications.mentions"
                                  :change_status="subactivities_info.row.notifications.change_status"
                                  :comments="subactivities_info.row.notifications.comments"
                                  :documents="subactivities_info.row.notifications.documents"
                                  :assignments_warnings="subactivities_info.row.notifications.assignments_warnings"
                                  :enabledChangedStatus="true"
                                  :enabledActualDates="enabledActualDates"
                                  :actual_dates_required="verifyRequiredActualDates(subactivities_info.row)"
                                />
                              </template>
                            </b-table-column>

                            <b-table-column field="context_menu" label="" cell-class="w-8 vertical-center" centered>
                              <template v-slot="subactivities_info">
                                <template v-if="subactivities_info.row.access">
                                  <div class="text-center cursor-pointer" @click.stop>
                                    <b-dropdown aria-role="list" position="is-bottom-left">
                                      <template #trigger="{ active }">
                                        <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                                      </template>
                                      <b-dropdown-item
                                        v-if="canManageActivity(subactivities_info.row)"
                                        aria-role="listitem"
                                        @click="onEditActivityClicked(subactivities_info.row)"
                                      >
                                        <span class="text-xs">{{ $t('edit') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        v-if="canCreateAssignments(subactivities_info.row)"
                                        aria-role="listitem"
                                        :disabled="!canCreateTaskOrResourceFromList(subactivities_info.row)"
                                        @click="onCreateAssignments(subactivities_info.row, 'task')"
                                      >
                                        <span class="text-xs">{{ $t('add_measurement_title') }} — {{ $t('task') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        v-if="canCreateAssignments(subactivities_info.row)"
                                        aria-role="listitem"
                                        :disabled="!canCreateTaskOrResourceFromList(subactivities_info.row)"
                                        @click="onCreateAssignments(subactivities_info.row, 'resource')"
                                      >
                                        <span class="text-xs">{{ $t('add_measurement_title') }} — {{ $t('resource') }}</span>
                                      </b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </template>
                              </template>
                            </b-table-column>

                          </template>

                          <template slot="detail" slot-scope="child">
                            <!--Mediciones -->
                            <div class="mb-1" v-if="displayAssignments(child.row)">
                              <div>
                                <h4>
                                  <b>{{ $t('measurements') }}</b>
                                </h4>
                              </div>

                              <assignment-table :ref="'assignments_' + child.row.id" :list="child.row.assignments" :entityId="child.row.id"
                                                :activityName="child.row.name"
                                                :subactivityId="child.row.is_subactivity ? child.row.id : null"
                                                :activityId="child.row.is_subactivity ? child.row.parent_id : child.row.id"
                                                :entityBlockedAssignments="child.row.blocked_assignments == 1"
                                                :canManageCertifiers="!!child.row.is_project_certifier"
                                                :canRecordActualprogress="!!child.row.is_project_progress"
                                                :currentStartDate="child.row.current_start_date"
                                                :currentEndDate="child.row.current_end_date"
                                                :lockedTasks="!!(project && project.has_westop) || (child.row.task_status == 0) || (child.row.task_status == 5) || (child.row.parent_task_status == 5)"
                                                :canManage="!!child.row.is_project_manager"
                                                :apiProject="apiProject"
                                                @reload="reloadSubActivities"/>
                            </div>
                          </template>
                        </b-table>
                      </template>

                    </div>
                </div>
                <!-- <footer class="card-footer">
                </footer> -->
              </b-collapse>
            </div>
          </template>
        </b-table>
      </template>
    </div>

    <viewer-pdf ref="modalViewerPdf" :fileName="fileName"></viewer-pdf>

    <!-- Mismo modal que en activity-assignments (añadir medición recurso) -->
    <assignment-modal
      v-if="assignmentModalActivityId !== null"
      ref="assignment_modal"
      entity-type="activity"
      :entity-id="assignmentModalActivityId"
      @reload="onAssignmentModalReload"
    />

    <task-modal
      v-if="taskModalActivityId !== null"
      ref="task_modal"
      entity-type="activity"
      :entity-id="taskModalActivityId"
      @reload="onTaskModalReload"
    />

    <!-- Actualiza la tabla automáticamente, de momento se queda -->
    <!-- <mugen-scroll :handler="fetchData" :should-handle="!isLoadingTable" scroll-container="wrap"></mugen-scroll>
    <b-loading :is-full-page="false" :active.sync="isLoadingTable" :can-cancel="false"></b-loading> -->

  </div>
</template>

<script>
import Vue from "vue"
import axios from 'axios'
import {mapGetters} from 'vuex'
import Form from 'vform'
import activityTimeStatus from '·/components/activity-time-status'
import activityStatusLabel from '·/components/activity-status-label'
import assignmentTable from '·/components/assignment-table'
import assignmentModal from '·/components/assignment-modal'
import taskModal from '·/components/task-modal'
import projectReport from '·/components/project-report'
import projectReportExcel from '·/components/project-report-excel'
import projectReportLotes from '·/components/project-report-lotes'
import projectReportSanea from '·/components/project-report-sanea'
import moment from 'moment'
import entityNotifications from '·/components/entity-notifications'
import MugenScroll from 'vue-mugen-scroll'
import Buefy from 'buefy'
import BIcon from "buefy/src/components/icon/Icon";
import EventBus from '~/plugins/bus'
import ActivityFilters from '·/components/activity-filters';
import Multiselect from 'vue-multiselect'
import QuickButtonMenu from '../../components/quick-button-menu/quick-button-menu.vue'
import ViewerPdf from "·/components/viewer-pdf.vue";
import { quantityDisplayDecimals } from '·/helpers/quantity-display'

Vue.use(Buefy);

export default {
  middleware: 'auth',
  title: 'activities_page_title',
  subtitle: 'activities_page_subtitle',
  menuOption: '2-2',

  components: {
    BIcon,
    activityTimeStatus,
    activityStatusLabel,
    entityNotifications,
    projectReport,
    projectReportExcel,
    projectReportLotes,
    projectReportSanea,
    assignmentTable,
    assignmentModal,
    taskModal,
    MugenScroll,
    ActivityFilters,
    Multiselect,
    QuickButtonMenu,
    ViewerPdf
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      project: 'app/project',
      company: 'app/company',
      visualConfig: 'app/visualConfig',
      mobile: 'device/mobile'
    }),

    isWeeklyWorkMode() {
      const configs = this.project && this.project.configs
      return !!(configs && configs.progress_type === 'weekly')
    },

    displayDecimals() {
      return quantityDisplayDecimals(this.project)
    },

    _columns: function() {
      // return Object.values(this.columns)
      // Object.keys(myObject).map(key => myObject[key]);
      return Object.entries(this.columns).map(([key, value]) => ({ key, title: this.$t(value.title), visible: value.visible }));
    },

    stickyHeader() { return this.mobile.on_mobile}, // para fijar el header de la tabla cuando se esta mostrando en movil

    limitShowColumnsSelect() { // cantidad de columnas visibles seleccionadas a mostrar en el multiselect por defecto  8
      return this.mobile.on_mobile ? 3 : 8
    },

    progressLabel() {
      let label = this.$t('progress_label');
      if (this.company.alias == 'welink') {
        label = this.$t('progress_inspected_label');
      }
      return label;
    },

    /** Filas de la tabla principal con el panel detailed abierto (solo una a la vez en esta vista). */
    mainOpenedDetailedIds() {
      return this.openedSubactivitiesId ? [this.openedSubactivitiesId] : []
    },

    filteredColumns() {
      // La configuración del proyecto es la fuente de verdad.
      // Solo aparecen en el filtro las columnas que el admin ha habilitado (visible: true).
      let projectColumnsConfig = this.project?.configs?.activities_columns || {};
      let allowedKeys = Object.keys(projectColumnsConfig).filter(
        key => projectColumnsConfig[key]?.visible === true
      );

      const companyHasSubtasks = this.company && this.company.configs && this.company.configs.subtasks == true;

      // Sin config de proyecto: mostrar todas excepto las que requieren activación explícita del admin
      if (allowedKeys.length === 0) {
        return this._columns.filter(col => {
          if (this.columns[col.key]?.adminRequired) return false;
          // task_status solo aplica si la empresa tiene subtasks habilitado
          if (col.key === 'task_status' && !companyHasSubtasks) return false;
          return true;
        });
      }

      // Estricto: solo columnas que el admin habilitó y que existen en this.columns
      let validKeys = allowedKeys.filter(key => this.columns[key]);

      // Si no hay kanban, excluye status_id
      if (!this.hasStatusList()) {
        validKeys = validKeys.filter(key => key !== 'status_id');
      }

      // task_status solo aplica si la empresa tiene subtasks habilitado
      if (!companyHasSubtasks) {
        validKeys = validKeys.filter(key => key !== 'task_status');
      } else if (!validKeys.includes('task_status') && projectColumnsConfig['task_status'] === undefined) {
        // El proyecto aún no tiene config para esta columna: por defecto visible
        validKeys.push('task_status');
      }

      // Muestra todas las columnas permitidas por el proyecto (el usuario puede activar/desactivar)
      return validKeys.map(key => ({
        key,
        title: this.$t(this.columns[key].title),
        visible: this.columns[key].visible
      }));
    }

  },

  data: () => ({
    form: new Form({
      creator: 'Todos',
      fecha: '1 Enero 2018 - 31 Diciembre 2018',
    }),
    // paginationRows: 10,
    isLoadingTable: true,
    page: 1,
    last: 1,
    perPage: 25,
    currentPage: 1,
    total: 0,
    orderField: "planning_code",
    orderDir: "asc",
    list: [],
    filterSubactivities: false,
    filterInPlanningLocal: 0,
    filterOutPlanningLocal: 0,
    showSubs: false,
    openedSubactivitiesId: 0,
    /** Subactividades (ids) con el detailed abierto bajo el padre `openedSubactivitiesId`. */
    subactivityDetailedIds: [],
    subactivities: [],
    showFilters: false,
    generatedFilters: {}, // objeto con los filtros generados por el componente 'activity-filters'
    columns: {
      'in_planning': {title: 'in_planning', visible: true},
      'user': {title: 'manager', visible: true},
      'planning_code': {title: 'code', visible: true},
      'name': {title: 'name', visible: true},
      'location': {title: 'location', visible: true},
      'type': {title: 'type', visible: true},
      'original_progress': {title: 'baseline', visible: true},
      'latest_progress': { title: 'latest_updated_planning', visible: true},
      'progress': {title: 'progress', visible: true},
      'actual_progress': {title: 'actual_progress', visible: true},
      'current_start_date': {title: 'start_date', visible: true},
      'current_end_date': {title: 'end_date', visible: true},
      'gantt_expected_start_date': {title: 'expected_start_date', visible: false, adminRequired: true},
      'gantt_expected_end_date': {title: 'expected_end_date', visible: false, adminRequired: true},
      'gantt_real_end_date': {title: 'actual_end', visible: true},
      'gantt_real_start_date': {title: 'actual_start', visible: true},
      'status': {title: 'status', visible: true},
      'actual_status': {title: 'actual_status', visible: true},
      'task_status': {title: 'task_status', visible: true},
      'status_id': {title: 'custom_status', visible: true},
      'notifications': {title: 'notifications', visible: true},
    },
    showExcelReport: false,
    showLotesReport: false,
    showSaneaReport: false,
    isCanalYII: false, // si el proyecto es de algun plan de canal isabel II (plan red o plan sanea) 
    childStatusList: [], // lista status de componente activity-filters
    apiProject: {}, // algunas caracteristicas del proyecto actual devueltas por api (si user es certificador)
    columnsSelected: [],

    ignore_delayed_state: false,
    lastRow: null,
    layoutGeneral: null,
    fileName: '',

    enabledActualDates: false,

    /** Actividad (o subactividad) para la que se abre assignment-modal; null = modal no montado */
    assignmentModalActivityId: null,
    /** Idem para task-modal (añadir tarea, mismo criterio que assignment-task canAdd) */
    taskModalActivityId: null,
    /** Tras crear/editar medición: volver a cargar assignment-table del collapse (misma acción que al abrir mediciones) */
    pendingReloadAssignmentsForActivityId: null,

    // Consolidar refresh del listado cuando cambian mediciones (locks/issues) para actualizar padres/proyecto
    assignmentsActivityRefreshTimer: null
  }),

  mounted() {
    this.columnsSelected = this.filteredColumns.filter(column => column.visible)

    // habilitamos la opcion de notificar fechas reales si lo amerita (de momento solo welink)
    if (this.company.alias == 'welink') {
      this.enabledActualDates = true
    }

    // recupera de la localstore la pagina que estamos (util al volver de una validacion al listado)
    this.page = this.$store.getters["searchFilters/activities"].page || 1
    this.last = this.$store.getters["searchFilters/activities"].last || 1

    this.applyFilters(this.page);
    let self = this;

    // Muestra columna "mis estados" cuando el componente hijo 'activity-filters' recibe por api lista statusList
    EventBus.$on("statusListReceived", function (statusList) {
      self.childStatusList = statusList
    });

    // Si recibimos el evento refresh, refrescamos el componente
    EventBus.$on('refreshActivitiesNotifications', function (e) {
      self.isLoading = true;
      self.applyFilters(self.page);
    });

    // Si recibimos el evento refresh, refrescamos el componente
    EventBus.$on('refreshSubactivitiesNotifications', function (e) {
      self.isLoading = true;
      self.applyFilters(self.page);
    });

    // Cuando cambian mediciones (por ejemplo resolver bloqueos), refrescar el listado para
    // que se actualicen flags heredadas (task_status/parent_task_status) y/o WeStop a nivel de proyecto.
    const scheduleActivitiesRefresh = () => {
      if (self.assignmentsActivityRefreshTimer) {
        clearTimeout(self.assignmentsActivityRefreshTimer)
      }
      self.assignmentsActivityRefreshTimer = setTimeout(() => {
        self.assignmentsActivityRefreshTimer = null
        self.applyFilters(self.page)
        self.refreshOpenedSubactivities()
        self.refreshProjectStore()
      }, 150)
    }
    EventBus.$on("refreshAssignmentChangedNotifications", scheduleActivitiesRefresh);
    EventBus.$on("refreshAssignmentCreatedNotifications", scheduleActivitiesRefresh);
    EventBus.$on("refreshAssignmentDeletedNotifications", scheduleActivitiesRefresh);

    this.updateColumnsUserProgress();
  },

  beforeDestroy(){
    EventBus.$off("statusListReceived");
    EventBus.$off("refreshActivitiesNotifications");
    EventBus.$off("refreshSubactivitiesNotifications");
    EventBus.$off("refreshAssignmentChangedNotifications");
    EventBus.$off("refreshAssignmentCreatedNotifications");
    EventBus.$off("refreshAssignmentDeletedNotifications");
    if (this.assignmentsActivityRefreshTimer) {
      clearTimeout(this.assignmentsActivityRefreshTimer)
      this.assignmentsActivityRefreshTimer = null
    }
  },

  created() {
    this.updateColumnsConfig()
    this.getLayoutGeneral()
    // ojo estos flags de report tambien estan en activity-groups.vue
    this.showExcelReport = (
      window.location.hostname.includes('test') ||
      this.user.company.id == 16 ||
      this.company.alias == 'tsk' ||
      this.company.alias == 'x-elio' ||
      this.company.alias == 'welink' ||
      this.company.alias == 'tci' ||
      this.company.alias == 'eag' ||
      this.company.alias == 'ohla-mexico'
    )
      ? true : false

    this.showLotesReport = this.company.configs && this.company.configs.loteCanal
    this.showSaneaReport = this.project.configs && this.project.configs.is_plan_sanea === true

    this.isCanalYII = this.showLotesReport || this.showSaneaReport; // si es alguno de los dos planes, es una proyecto de Canal

    this.ignore_delayed_state = this.visualConfig && this.visualConfig.ignore_delayed_state
  },

  watch: {
    // Cuando la config del proyecto cambia (Vuex reactivo), limpiar columnsSelected
    // para eliminar automáticamente cualquier columna que ya no esté permitida.
    filteredColumns(newColumns) {
      const allowedKeys = new Set(newColumns.map(c => c.key));
      this.columnsSelected = this.columnsSelected.filter(c => allowedKeys.has(c.key));
      // También sincronizar el visible de this.columns para la tabla
      Object.keys(this.columns).forEach(key => {
        if (!allowedKeys.has(key)) {
          this.columns[key].visible = false;
        }
      });
    }
  },

  methods: {
    async refreshProjectStore() {
      try {
        if (!this.project || !this.project.id) return
        const { data } = await axios.get('/api/v2/project/' + this.project.id)
        const project = (data && data.project) ? data.project : data
        if (project) this.$store.dispatch('app/setProject', { project })
      } catch (e) {
        // silent: no bloquear UX por refresh
      }
    },

    async refreshOpenedSubactivities() {
      try {
        const parentId = this.openedSubactivitiesId
        if (!parentId) return
        let url = '/api/v2/activity/' + parentId + '/subactivities';
        let params = { with_location: 1, with_prelations: 1 }
        const { data } = await axios.get(url, { params })
        if (data && data.success) {
          this.subactivities[parentId] = this.activitiesRemapping(data.subactivities)
        }
      } catch (e) {
        // silent
      }
    },

    onEditActivityClicked(activity) {
      if (!activity || !activity.id) return

      // Si fuese una subactividad en este listado, usar la ruta de edición de subactividad.
      if (activity.is_subactivity) {
        this.$router.push({
          name: 'subactivity.edit',
          params: {
            activity_id: activity.parent_id,
            subactivity_id: activity.id,
          }
        })
        return
      }

      this.$router.push({
        name: 'activity.edit',
        params: { activity_id: activity.id }
      })
    },
    onCreateSubactivity(activity) {
      if (!activity || !activity.id) return
      this.$router.push({
        name: 'subactivity.create',
        params: {
          // `ActivityEdit` espera `activity_id` y usa `name` para el subtítulo
          activity_id: activity.id,
          name: activity.name,
          id: activity.id,
        }
      })
    },
    isActivityClosed(activity) {
      return activity && activity.status === 6
    },
    canManageActivity(activity) {
      // se usa los mismos permisos que para la edición de actividad y la creación de subactividades
      if (!activity) return false
      return (activity.is_creator || activity.is_manager || activity.is_project_manager) && !this.isActivityClosed(activity)
    },
    canCreateAssignments(row) {
      // - Parent activity: solo si NO tiene subactividades
      // - Subactivity: siempre (por ahora)
      if (!row) return false
      if (row.is_subactivity || row.isSubactivity) return true

      const subNum = Number(row.subactivities_num || 0)
      return subNum <= 0
    },
    /**
     * Igual que canEditAssignments() en activity-assignments: si las mediciones están bloqueadas,
     * solo quien gestiona certificadores puede crear/editar mediciones.
     */
    canEditAssignmentsForActivity(row) {
      if (!row) return false
      const assignmentsLocked = !!row.blocked_assignments
      const canManageCertifiers = !!row.is_project_certifier
      return !assignmentsLocked || (assignmentsLocked && canManageCertifiers)
    },
    /**
     * Mismo criterio que :can-add en activity home → assignment-task (is_project_manager y actividad no cerrada).
     */
    canAddAssignmentsForActivity(row) {
      if (!row) return false
      return !!row.is_project_manager && !this.isActivityClosed(row)
    },
    /**
     * Añadir medición (tarea o recurso) desde el listado: bloqueo + certificador + permiso de alta en actividad.
     */
    canCreateTaskOrResourceFromList(row) {
      return this.canEditAssignmentsForActivity(row) && this.canAddAssignmentsForActivity(row)
    },
    onCreateAssignments(row, type) {
      if (!row || !row.id || !type) return

      if (!this.canCreateTaskOrResourceFromList(row)) return

      if (type === 'task') {
        this.taskModalActivityId = row.id
        this.$nextTick(() => {
          const modal = this.$refs.task_modal
          if (modal) modal.show()
        })
        return
      }

      if (type === 'resource') {
        this.assignmentModalActivityId = row.id
        const siblingResources = (row.assignments || []).filter(
          (a) => a.type === 'resource' && a.is_header_row == 0
        )
        this.$nextTick(() => {
          const modal = this.$refs.assignment_modal
          if (modal) modal.show(null, siblingResources)
        })
      }
    },

    onAssignmentModalReload() {
      this.pendingReloadAssignmentsForActivityId = this.assignmentModalActivityId
      this.isLoadingTable = true
      this.applyFilters(this.page)
    },

    onTaskModalReload() {
      this.pendingReloadAssignmentsForActivityId = this.taskModalActivityId
      this.isLoadingTable = true
      this.applyFilters(this.page)
    },
    async getActivitiesList(args = []) {
      args.include_parents_for_accessible_children = 1;
      const {data} = await axios.get('/api/v2/activities', {params: args});
      // Last and total
      this.last = data.lastPage;
      this.total = data.total;
      this.apiProject = data.project;
      // guarda en la localstore la ultima pagina
      this.$store.dispatch('searchFilters/setActivitiesFilters', { last: this.last });

      if (data && data.activities) {
        //deducimos si no tiene status kanban aplicados y los ocultamos
        if (!this.hasStatusList())
          delete this.columns.status_id;

        this.list = this.activitiesRemapping(data.activities);
      } else {
        this.$notify.error('error_loading_activities')
      }

      const pendingAssignmentsActivityId = this.pendingReloadAssignmentsForActivityId
      this.pendingReloadAssignmentsForActivityId = null

      this.isLoadingTable = false

      this.$nextTick(() => {
        if (pendingAssignmentsActivityId != null) {
          const tableRef = this.$refs['assignments_' + pendingAssignmentsActivityId]
          if (tableRef && typeof tableRef.loadAssignments === 'function') {
            tableRef.loadAssignments(pendingAssignmentsActivityId)
          }
        }
        this.restoreActivitiesDetailFromSession()
      })
    },

    /**
     * Remapea la actividad para esta tabla
     */
    activitiesRemapping(activities) {
      for (let a in activities) {
        // ya que estamos calculamos aqui los progresos
        if (this.project.can_progress) {
          activities[a].original_progress = this.calculateProgress(activities[a].scheduled_start_date, activities[a].scheduled_end_date);
          activities[a].latest_progress = this.calculateProgress(activities[a].current_start_date, activities[a].current_end_date);
        }
        if (activities[a].assignments && activities[a].assignments.length > 0) {
          activities[a].alert = 0;
          for (let i in activities[a].assignments) {
            let number = this.getAssignmentExecutionStatus(activities[a].assignments[i]);
            activities[a].assignments[i].execution_status = number;

            if (activities[a].alert !== number && activities[a].alert !== 1)
              activities[a].alert = number;

          }
        }
      }
      return activities;
    },

    filtersUpdated() {
      this.isLoadingTable = true;
      this.applyFilters(1);
    },

    customizeFilters() {
      let filters = this.$refs.filtersRef.generateFilters();
      // ya no mandamos este parametro para que no cargue las mediciones parte de una optimización de carga del listado
      // filters.with_assignments = 1;
      filters.order_field = this.orderField;
      filters.order_dir = this.orderDir;
      filters.per_page = this.perPage;
      //filters.s = 1; //con subactividades. Como se piden de todas formas al desplegar, se quitan de aqui para aligerar carga

      // Manejo de los fast filters (switches bajo filtros)
      // No es perfecto
      if (filters.filter_in_planning && filters.filter_in_planning == 1) {

        // si desde el subcomponente activity-filters recibimos valor para in_planning, este prevalece sobre el local (fast filter)
        this.filterInPlanningLocal = 1
        this.filterOutPlanningLocal = 0

      } else if (filters.filter_in_planning && filters.filter_in_planning == 0) {

        this.filterInPlanningLocal = 0
        this.filterOutPlanningLocal = 1

      } else {

        // si no recibimos valor, pero tenemos valor local (fast filter), lo enviamos
        if (this.filterInPlanningLocal) {
          filters.filter_in_planning = 1
        }
        if (this.filterOutPlanningLocal) {
          filters.filter_in_planning = 0
        }

      }

      if (this.filterSubactivities) {
        filters.filter_subactivities = 1
      }
      filters.with_location = 1
      filters.with_prelations = 1
      filters.with_fullpath = 1

      return filters;
    },

    onRowClicked(isSubactivity, activityId, subactivityId, access = true) {
      if (access) {
        if (!isSubactivity) {
          this.$router.push({name: 'activity.home', params: {activity_id: activityId}})
        } else {
          this.$router.push({
            name: 'subactivity.home',
            params: {activity_id: activityId, subactivity_id: subactivityId}
          })
        }
      }
    },

    onCreateActivityClicked() {
      let url = '/api/v2/locations?all=1&p=' + this.project.id;
      self = this;
      axios.get(url)
        .then(function (response) {
          if (response.data && response.data.success && response.data.locations) {
            self.$router.push({name: 'activity.create'})
          } else {
            self.$notify.error('project_without_locations_create_activity')
          }
        });
    },

    updateColumnsUserProgress() {
      const canProgress = this.project.can_progress;

      const showEstimated = !canProgress;
      const showReal = canProgress;

      const estimatedColumns = ['status'];
      const realColumns = ['actual_progress', 'actual_status','gantt_real_start_date', 'gantt_real_end_date', 'original_progress', 'latest_progress'];

      estimatedColumns.forEach(column => {
        if (this.columns[column]) {
          this.columns[column].visible = showEstimated;
        }
      });

      realColumns.forEach(column => {
        if (this.columns[column]) {
          this.columns[column].visible = showReal;
        }
      });

      this.updateColumnsConfig()
    },

    displayKanban() {
      this.$router.push({name: 'project.activities.kanban'});
    },

    displayGantt() {
      this.$router.push({name: 'project.activities.gantt'});
    },

    goToWeeklyPlanningView() {
      this.$router.push({ name: 'project.activities.weekly' });
    },

    async addFavorite(activityId, index, isSubactivity = false) {
      let url = '/api/v2/user/' + activityId + '/favorite/add';
      const {data} = await axios.post(url);
      if (data && data.success) {
        //refrescamos la tabla
        if (isSubactivity) {
          // Recorremos las subactividades de la actividad abierta y buscamos la subactividad para actualizarla
          // No podemos utilizar el index ya que si las subactividades han sido reordenadas éste se queda desfasado
          let i = 0;
          let found = false;
          while (!found && i <= this.subactivities[this.openedSubactivitiesId].length) {
            if (this.subactivities[this.openedSubactivitiesId][i].id === activityId) {
              this.subactivities[this.openedSubactivitiesId][i].favorite = true;
              found = true
            }
            i++
          }

        } else {
          this.list[index].favorite = true;
        }

      } else {
        this.$notify.error('error_add_favorite')
      }
    },

    async deleteFavorite(activityId, index, isSubactivity = false) {
      let url = '/api/v2/user/' + activityId + '/favorite/delete';
      const {data} = await axios.post(url);
      if (data && data.success) {
        //refrescamos la tabla
        if (isSubactivity) {
          // Recorremos las subactividades de la actividad abierta y buscamos la subactividad para actualizarla
          // No podemos utilizar el index ya que si las subactividades han sido reordenadas éste se queda desfasado
          let i = 0;
          let found = false;
          while (!found && i <= this.subactivities[this.openedSubactivitiesId].length) {
            if (this.subactivities[this.openedSubactivitiesId][i].id === activityId) {
              this.subactivities[this.openedSubactivitiesId][i].favorite = false
              found = true
            }
            i++
          }
        } else {
          this.list[index].favorite = false;
        }
      } else {
        this.$notify.error('error_add_favorite')
      }
    },

    async createProjectDossier() {
      //TO-DO: realizar llamada al generador de informes para el proyecto this.project.id
      return true
    },

    showSubactivities(activityId) {
      this.showSubs = (!this.showSubs);
    },

    applyFilters(page) {
      this.generatedFilters = this.customizeFilters();
      this.generatedFilters.page = (page <= this.last) ? page : 1;
      // actualiza en localstore la pagina actual
      this.$store.dispatch('searchFilters/setActivitiesFilters', { page: this.generatedFilters.page });
      this.currentPage = this.generatedFilters.page;
      this.getActivitiesList(this.generatedFilters)
    },

    fetchData() {
      if (this.page <= this.last) {
        this.isLoadingTable = true;
        this.applyFilters(this.page);
        // this.isLoadingTable = false. Se hace dentro de getActivitiesList
      }
    },

    onPageChange(page) {
      // guarda en la localstore la pagina que estamos
      this.$store.dispatch('searchFilters/setActivitiesFilters', { page: page });
      this.clearActivitiesDetailUiState()
      this.page = page;
      this.fetchData()
    },

    onSort(field, order) {
      this.clearActivitiesDetailUiState()
      this.orderField = field;
      this.orderDir = order;
      this.fetchData()
    },

    displaySubactivities(row) {
      return !row.isSubactivity && row.subactivities_num > 0
    },

    displayAssignments(row) {
      return row.assignments_num > 0;
      // return (row.assignments && row.assignments.length > 0);
    },

    displaySubactivitiesOrAssignments(row) {
      return !!(this.displayAssignments(row) || this.displaySubactivities(row));
    },

    activitiesDetailSessionKey() {
      if (!this.project || !this.project.id) return null
      return 'epc_activities_detail_quick_' + this.project.id
    },

    clearActivitiesDetailUiState() {
      this.openedSubactivitiesId = 0
      this.subactivityDetailedIds = []
      try {
        const key = this.activitiesDetailSessionKey()
        if (key) sessionStorage.removeItem(key)
      } catch (e) {
        // ignorar
      }
    },

    persistActivitiesDetailSession() {
      try {
        const key = this.activitiesDetailSessionKey()
        if (!key) return
        const parentId = this.openedSubactivitiesId
        if (!parentId) {
          sessionStorage.removeItem(key)
          return
        }
        let subs = [...this.subactivityDetailedIds]
        const list = this.subactivities[parentId]
        if (list && list.length) {
          const valid = new Set(list.map((s) => s.id))
          subs = subs.filter((id) => valid.has(id))
        }
        sessionStorage.setItem(key, JSON.stringify({ p: parentId, subs }))
      } catch (e) {
        // ignorar quota / privado
      }
    },

    restoreActivitiesDetailFromSession() {
      try {
        const key = this.activitiesDetailSessionKey()
        if (!key) return
        const raw = sessionStorage.getItem(key)
        if (!raw) return
        const parsed = JSON.parse(raw)
        const parentId = parsed && parsed.p
        const subs = parsed && Array.isArray(parsed.subs) ? parsed.subs : []
        if (!parentId) return

        const parentRow = this.list.find(
          (r) => r.id === parentId && r.without_access !== 1 && this.displaySubactivitiesOrAssignments(r)
        )
        if (!parentRow) {
          return
        }

        const applyOpenedState = () => {
          this.openedSubactivitiesId = parentId
          const subList = this.subactivities[parentId] || []
          const validIds = new Set(subList.map((s) => s.id))
          this.subactivityDetailedIds = subs.filter((id) => validIds.has(id))
          this.handleRowSelected(parentRow, true)
          this.$nextTick(() => {
            this.subactivityDetailedIds.forEach((sid) => {
              const tableRef = this.$refs['assignments_' + sid]
              if (tableRef && typeof tableRef.loadAssignments === 'function') {
                tableRef.loadAssignments(sid)
              }
            })
            this.persistActivitiesDetailSession()
          })
        }

        if (typeof this.subactivities[parentId] === 'undefined') {
          this.isLoadingTable = true
          const url = '/api/v2/activity/' + parentId + '/subactivities'
          const params = { with_location: 1, with_prelations: 1 }
          axios.get(url, { params }).then((response) => {
            if (response.data && response.data.success) {
              this.subactivities[parentId] = this.activitiesRemapping(response.data.subactivities)
            }
            this.isLoadingTable = false
            applyOpenedState()
          }).catch(() => {
            this.isLoadingTable = false
          })
        } else {
          applyOpenedState()
        }
      } catch (e) {
        // JSON inválido u otro error
      }
    },

    onMainDetailsClose(row, index) {
      this.openedSubactivitiesId = 0
      this.subactivityDetailedIds = []
      this.persistActivitiesDetailSession()
    },

    openDetails(row, index) {
      if (this.openedSubactivitiesId && this.openedSubactivitiesId !== row.id) {
        this.subactivityDetailedIds = []
      }

      if (typeof this.subactivities[row.id] === 'undefined') {
        this.isLoadingTable = true;
        let self = this;
        let url = '/api/v2/activity/' + row.id + '/subactivities';
        // let params = {with_assignments: 1};
        let params = {
          with_location: 1,
          with_prelations: 1
        }; // para optimizar la carga solo cargamos las actividades
        axios.get(url, {params: params}).then(function (response) {
          if (response.data && response.data.success) {
            // Remapea las subactividades para calcular los progresos y otros campos
            self.subactivities[row.id] = self.activitiesRemapping(response.data.subactivities);
          }
          self.isLoadingTable = false;
          self.openedSubactivitiesId = row.id
          self.persistActivitiesDetailSession()
          self.handleRowSelected(row, true) // TODO. Debug, hay que pasar self.lastRow o row??
        })
      } else {
        this.isLoadingTable = false;
        this.openedSubactivitiesId = row.id
        this.persistActivitiesDetailSession()
        this.handleRowSelected(row, true) // TODO. Debug, hay que pasar self.lastRow o row??
      }
    },

    onNestedDetailsOpen(row, index) {
      if (!this.subactivityDetailedIds.includes(row.id)) {
        this.subactivityDetailedIds.push(row.id)
      }
      this.persistActivitiesDetailSession()
      this.$nextTick(() => {
        const ref = this.$refs['assignments_' + row.id]
        if (ref && typeof ref.loadAssignments === 'function') {
          ref.loadAssignments(row.id)
        }
      })
    },

    onNestedDetailsClose(row, index) {
      this.subactivityDetailedIds = this.subactivityDetailedIds.filter((id) => id !== row.id)
      this.persistActivitiesDetailSession()
    },

    /** Collapse "Mediciones" en el detailed del padre (no es el detailed de la tabla de subactividades). */
    onMeasurementsCollapseOpen(activityRow) {
      if (!activityRow || !activityRow.id) return
      this.$nextTick(() => {
        const ref = this.$refs['assignments_' + activityRow.id]
        if (ref && typeof ref.loadAssignments === 'function') {
          ref.loadAssignments(activityRow.id)
        }
      })
    },

    getSubactivities(row) {
      return this.subactivities[row.id]
    },

    getVisibleSubactivitiesCount(row) {
      if (!this.subactivities[row.id]) {
        return 0
      }
      return this.subactivities[row.id].filter(subactivity => subactivity.access).length
    },

    getRowClass(row, index) {
      // (row, index) => ! row.parent_access ? '' : 'is-hidden'
      let cssClass = 'row_' + row.id;
      if (row.parent_access && !this.filterSubactivities) {
        cssClass += ' is-hidden'
      } else if (row.subactivities_notifications) {
        cssClass += ' sub-notifications'
      }

      return cssClass
    },

    getSubRowClass(row, index) {
      let cssClass = 'row_' + row.id;
      if (!row.access) {
        cssClass += ' is-hidden'
      }
      return cssClass
    },

    checkFilterSubactivities() {
      this.filterSubactivities = !this.filterSubactivities;
      this.isLoadingTable = true;
      this.applyFilters(1)
    },

    checkFilterInPlanningLocal() {
      this.filterInPlanningLocal = this.filterInPlanningLocal ? 0 : 1; // toggle
      this.filterOutPlanningLocal = this.filterInPlanningLocal ? 0 : this.filterOutPlanningLocal; // si activamos IN, desactivamos OUT, si no dejar como estaba
      this.isLoadingTable = true;
      this.applyFilters(1)
    },

    checkFilterOutPlanningLocal() {
      this.filterOutPlanningLocal = this.filterOutPlanningLocal ? 0 : 1; // toggle
      this.filterInPlanningLocal = this.filterOutPlanningLocal ? 0 : this.filterInPlanningLocal; // si activamos OUT, desactivamos IN, si no dejar como estaba
      this.isLoadingTable = true;
      this.applyFilters(1)
    },

    sortByCode() {
      //ya viene asi de backend
    },

    sortByNotifications(a, b, isAsc) {
      return isAsc ?
        a.notifications.total - b.notifications.total :
        b.notifications.total - a.notifications.total
    },

    sortByFavorite(a, b, isAsc) {
      return isAsc ?
        (+a.favorite) - (+b.favorite) :
        (+b.favorite) - (+a.favorite)
    },

    sortByShowOnDevices() {

    },

    hasStatusList() {
      return this.childStatusList.length > 0;
      // return this.$refs.filtersRef.hasStatusList(); // da error por componente todavia no montado (ahora usamos emit-on)
    },

    getStatusIdName(id) {
      let status = this.$refs.filtersRef.statusList.find(b => b.id == id);

      if (status)
        return status.name;

      return '';
    },

    getAssignmentStatusColor(row) {
      switch (row.alert) {
        case -1:
          return 'bg-blue';

        case 0:
          return 'bg-green';

        case 1:
          return 'bg-red';

        default:
          return 'bg-blue';
      }
    },

    getAssignmentStatusLabel(row) {
      switch (row.alert) {
        case -1:
          return 'assignments-under';

        case 0:
          return 'assignments-completed';

        case 1:
          return 'assignments-over';
      }
    },

    /**
     * Calcula el estado de la medición
     * @param row
     * @returns {number}
     */
    getAssignmentExecutionStatus(row) {
      if (row.type === 'task')
        if (row.completed)
          return 0; // perfecto
        else return -1;// por debajo, tarea aun no completada

      if (row.executed_quantity < row.total)
        return -1; // por debajo
      else if (row.executed_quantity > row.total)
        return 1; // por encima
      else return 0; // cantidad exacta
    },

    reloadActivities(data) {
      if (data && data.entityId != null) {
        this.pendingReloadAssignmentsForActivityId = data.entityId
      }
      this.applyFilters(this.page);
    },

    reloadSubActivities(data) {
      if (data && data.entityId != null) {
        this.pendingReloadAssignmentsForActivityId = data.entityId
      }
      this.applyFilters(this.page);
    },

    async showOnDevice(activityId, index, isSubactivity = false) {
      if( !this.project.can_admin)
        return;
      let url = '/api/v2/activity/' + activityId + '/showOnDevices';
      const {data} = await axios.post(url, {'show' : 1});
      // const {data} = await axios.post(url, {params: {'show' : 1}});
      if (data && data.success) {
        //refrescamos la tabla
        if (isSubactivity) {
          // Recorremos las subactividades de la actividad abierta y buscamos la subactividad para actualizarla
          // No podemos utilizar el index ya que si las subactividades han sido reordenadas éste se queda desfasado
          let i = 0;
          let found = false;
          while (!found && i <= this.subactivities[this.openedSubactivitiesId].length) {
            if (this.subactivities[this.openedSubactivitiesId][i].id === activityId) {
              this.subactivities[this.openedSubactivitiesId][i].show_on_devices = true;
              found = true
            }
            i++
          }

        } else {
          this.list[index].show_on_devices = true;
          if( this.subactivities[this.openedSubactivitiesId] )
            this.subactivities[this.openedSubactivitiesId].forEach( function(item, indice, array) {
              item.show_on_devices = true
            });
        }

      } else {
        this.$notify.error('error_add_favorite')
      }
    },

    async hideOnDevice(activityId, index, isSubactivity = false) {
      if( !this.project.can_admin)
        return;
      let url = '/api/v2/activity/' + activityId + '/showOnDevices';
      const {data} = await axios.post(url, {'show' : 0});
      if (data && data.success) {
        //refrescamos la tabla
        if (isSubactivity) {
          // Recorremos las subactividades de la actividad abierta y buscamos la subactividad para actualizarla
          // No podemos utilizar el index ya que si las subactividades han sido reordenadas éste se queda desfasado
          let i = 0;
          let found = false;
          while (!found && i <= this.subactivities[this.openedSubactivitiesId].length) {
            if (this.subactivities[this.openedSubactivitiesId][i].id === activityId) {
              this.subactivities[this.openedSubactivitiesId][i].show_on_devices = false
              found = true
            }
            i++
          }
        } else {
          this.list[index].show_on_devices = false;
          if( this.subactivities[this.openedSubactivitiesId] )
            this.subactivities[this.openedSubactivitiesId].forEach( function(item, indice, array) {
              item.show_on_devices = false
            });
        }
      } else {
        this.$notify.error('error_add_favorite')
      }
    },

    getIssueIcon(activityTaskStatus) {
      
      const taskStatusMap = {
        0: { icon: 'hand', color: 'text-orange' }, // WESTOP_ACTIVITY
        1: { icon: 'hand', color: 'text-red' }, // WESTOP_PROJECT
        2: { icon: 'exclamation-triangle', color: 'text-yellow' }, // ISSUE_PENDING
        3: { icon: 'exclamation-triangle', color: 'text-orange' }, // ISSUE_WITHOUT_LOCK
        4: { icon: 'exclamation-triangle', color: 'text-red' }, // ISSUE_LOCK_TASK
        5: { icon: 'hand', color: 'text-red' } // WESTOP_ACTIVITY_parent
      }

      return taskStatusMap[activityTaskStatus] || null
      
    },

    goToPage(destiny = 'drawings') {

      switch (destiny) {

        case 'drawings':
            this.$router.push({ name: 'project.drawings' })
            break;
        case 'groups': // ver la vista de actividades agrupadas
            this.$router.push({ name: 'project.activities.groups' })
            break;
      }

    },

    colorGroup(group){
      let defaultColor = "#F29B57"
      let configs = JSON.parse(group.configs)

      return configs && configs.color ? configs.color : defaultColor
    },

    nameGroup(group){
      return group.name.substring(0, 2).toUpperCase()
    },

    async updateColumnsConfig() {
      let userColumnsConfig = {};
      let projectColumnsConfig = {};

      try {
        const { data } = await axios.get(`/api/v2/user/${this.user.id}/configs`, {
          params: { project_id: this.project.id }
        });

        if (data && data.activities_columns) {
          userColumnsConfig = data.activities_columns;
        } else {
          userColumnsConfig = {};
        }
      } catch (e) {
        userColumnsConfig = {};
      }

      projectColumnsConfig = this.project?.configs?.activities_columns || {};

      Object.keys(this.columns).forEach(key => {
        // Project visible:false always wins — user cannot override a project-hidden column
        if (projectColumnsConfig[key]?.visible === false) {
          this.columns[key].visible = false;
        } else if (typeof userColumnsConfig[key]?.visible === 'boolean') {
          this.columns[key].visible = userColumnsConfig[key].visible;
        } else if (typeof projectColumnsConfig[key]?.visible === 'boolean') {
          this.columns[key].visible = projectColumnsConfig[key].visible;
        }
        // Si ninguno tiene config, se mantiene el valor por defecto
      });

      // Actualiza el multiselect con las columnas visibles y permitidas por el proyecto
      this.columnsSelected = this.filteredColumns.filter(column => column.visible);
    },

    _HandleSelectItem(selectedOption, id) {
      this.columns[selectedOption.key].visible = true;
      // Solo selecciona las permitidas por el proyecto y visibles
      this.columnsSelected = this.filteredColumns.filter(column => this.columns[column.key].visible);
      this.saveColumns();
    },

    _HandleRemoveItem(removedOption, id) {
      if (this.columns[removedOption.key])
        this.columns[removedOption.key].visible = false;
      // Solo selecciona las permitidas por el proyecto y visibles
      this.columnsSelected = this.filteredColumns.filter(column => this.columns[column.key].visible);
      this.saveColumns();
    },

    async saveColumns() {
      try {
        const response = await axios.post(`/api/v2/user/${this.user.id}/configs`, {
          activities_columns: this.columns,
          project_id: this.project.id
        });
        if (response.data && response.data.success === false) {
          this.$notify.error(response.data.message || this.$t('config_update_error'));
          return;
        }
        this.$notify.success('config_updated');
      } catch (error) {
        const message = error.response?.data?.message;
        this.$notify.error(message || this.$t('config_update_error'));
      }
    },

    quickButtonMenu() {
      let extraButtons = []
      if (this.layoutGeneral) {
        extraButtons.push({
          name: 'layout_general',
          text: this.$t('layout_general'),
          showText: true,
          icon: 'map',
          visible: true,
          tooltip: true,
          bgClass: 'bg-blue',
          textClass: 'text-white',
          handleOnClick: () => { this.showLayoutGeneral() }
        })
      }
      return [
        ...extraButtons,
        // Vista agrupación de actividades
        {
          name: 'activity_grouping_view',
          text: this.$t('activity_groups'),
          showText: true,
          icon: 'layer-group',
          visible: !this.project.can_collaborate,
          tooltip: true,
          handleOnClick: () => { this.goToPage('groups') }
        },

        // Crear actividad
        {
          name: 'create_activity',
          text: this.$t('add_activity'),
          showText: true,
          icon: 'plus',
          visible: this.project.can_admin,
          tooltip: true,
          handleOnClick: this.onCreateActivityClicked
        },
        // Botón para abrir diagrama de gantt
        {
          name: 'gantt_chart_view',
          text: this.$t('display_gantt'),
          showText: false,
          icon: 'chart-gantt',
          visible: !this.project.can_collaborate,
          tooltip: true,
          handleOnClick: this.displayGantt
        },
        // Botón para ver Kanban
        {
          name: 'kanban_view',
          text: this.$t('display_kanban'),
          showText: false,
          icon: 'columns',
          visible: this.project.can_admin,
          tooltip: true,
          handleOnClick: this.displayKanban
        },
        // Botón para ver Carpetas documentos
        {
          name: 'document_folder_view',
          text: this.$t('display_folders'),
          showText: false,
          icon: 'folder-plus',
          visible: true,
          tooltip: true,
          handleOnClick: () => { this.$router.push({name: 'project.activities.folders'}); }
        }
      ]
    },

    hasPrelations(activity) {
      return activity.next_activities?.length || activity.pre_activities?.length
    },

    goToPrelations(activity) {
      if (this.hasPrelations(activity)) {
        this.$router.push({ name: 'activity.prelation', params: {
                  activity_id: activity.id
                } })
      }
    },

    handleRowSelected(row, updateRows = false) {
      // A veces se llama aqui con row = null. Depurar, mientras parcheo
      if (!row) {
        console.warn('handleRowSelected: row is null or undefined');
        return;
      }

      this.$nextTick(() => {
        if (this.lastRow) {
          let lastRowElement = document.querySelector('.row_'+this.lastRow.id);
          if (lastRowElement) {
              lastRowElement.classList.remove('row-blue');
          }

          this.removeClassToNextRows(this.lastRow.next_activities)
          this.removeClassToPrevRows(this.lastRow.pre_activities)
          if (this.lastRow.id == row.id && !updateRows) {
            this.lastRow = null
            return;
          }
        }
        let rowElement = document.querySelector('.row_'+row.id);
        if (rowElement) {
            rowElement.classList.add('row-blue');
        }

        this.addClassToNextRows(row.next_activities)
        this.addClassToPrevRows(row.pre_activities)
        this.lastRow = row
      });
    },

    addClassToNextRows(nextActivities) {
      if (nextActivities) {
        for (let nextActivity of nextActivities) {
          let className = 'row-orange'
          let rowId = nextActivity.id
          if (nextActivity.parent_id) {
            className = 'row-red'

            let rowParentElement = document.querySelector('.row_'+nextActivity.parent_id);
            if (rowParentElement) {
                rowParentElement.classList.add(className);
            }
          }

          let rowElement = document.querySelector('.row_'+rowId);
          if (rowElement) {
              rowElement.classList.add(className);
          }

          // this.addClassToNextRows(nextActivity.all_next_activities)
        }
      }
    },

    removeClassToNextRows(nextActivities) {
      if (nextActivities) {
        for (let nextActivity of nextActivities) {
          let className = 'row-orange'
          let rowId = nextActivity.id
          if (nextActivity.parent_id) {
            className = 'row-red'

            let rowParentElement = document.querySelector('.row_'+nextActivity.parent_id);
            if (rowParentElement) {
                rowParentElement.classList.remove(className);
            }
          }

          let rowElement = document.querySelector('.row_'+rowId);
          if (rowElement) {
              rowElement.classList.remove(className);
          }

          // this.removeClassToNextRows(nextActivity.all_next_activities)
        }
      }
    },

    addClassToPrevRows(preActivities) {
      if (preActivities) {
        for (let preActivity of preActivities) {
          let className = 'row-green'
          let rowId = preActivity.id
          if (preActivity.parent_id) {
            className = 'row-green-dark'

            let rowParentElement = document.querySelector('.row_'+preActivity.parent_id);
            if (rowParentElement) {
                rowParentElement.classList.add(className);
            }
          }

          let rowElement = document.querySelector('.row_'+rowId);
          if (rowElement) {
              rowElement.classList.add(className);
          }

          // this.addClassToPrevRows(preActivity.all_pre_activities)
        }
      }
    },

    removeClassToPrevRows(preActivities) {
      if (preActivities) {
        for (let preActivity of preActivities) {
          let className = 'row-green'
          let rowId = preActivity.id
          if (preActivity.parent_id) {
            className = 'row-green-dark'

            let rowParentElement = document.querySelector('.row_'+preActivity.parent_id);
            if (rowParentElement) {
                rowParentElement.classList.remove(className);
            }
          }

          let rowElement = document.querySelector('.row_'+rowId);
          if (rowElement) {
              rowElement.classList.remove(className);
          }

          // this.removeClassToPrevRows(preActivity.all_pre_activities)
        }
      }
    },

    getLayoutGeneral() {
      let url = '/api/v2/document/project/' + this.project.id + '/layout-general';
      axios.get(url).then((response) => {
        if (response.data && response.data.success) {
          this.layoutGeneral = response.data.document
        } else {
          this.$notify.error('error_loading_documents')
        }
      })
    },

    showLayoutGeneral() {
      // adds timestamp to url to avoid showing cached previous versions
      let fileNameWithTimestamp = this.layoutGeneral.file.includes('?')
        ? this.layoutGeneral.file + '&' + Date.now()
        : this.layoutGeneral.file + '?' + Date.now()
      this.fileName = fileNameWithTimestamp
      this.$refs.modalViewerPdf.show();
      this.$refs.modalViewerPdf.getPdf();
    },

    // verificamos si la actividad necesita que le agreguen fechas reales
    verifyRequiredActualDates(activity) {
      if (this.enabledActualDates) {
        if (
          (parseInt(activity.progress_actual) > 0 && !activity.gantt_real_start_date) ||
          (parseInt(activity.progress_actual) === 100 && !activity.gantt_real_end_date)
        ) {
          return true;
        }
      }
      return false;
    },

    // calcula el porcentaje que ha pasado con respecto a la fecha de inicio y fin
    calculateProgress(startDate, endDate) {
      const format = "DD/MM/YYYY";
      const start = moment(startDate, format);
      const end = moment(endDate, format);
      const now = moment();

      if (now.isBefore(start)) {
        return 0;
      }

      if (now.isSameOrAfter(end)) {
        return 100;
      }

      const totalDuration = end.diff(start, 'milliseconds');
      const elapsedDuration = now.diff(start, 'milliseconds');
      const progress = (elapsedDuration / totalDuration) * 100;

      return parseFloat(progress.toFixed(5));
    },

    // ordenacion natural para planning_code (1.1, 1.2, ... 1.10)
    sortByPlanningCode(a, b, isAsc) {
      const aCode = (a.planning_code ?? '').toString();
      const bCode = (b.planning_code ?? '').toString();
      const cmp = aCode.localeCompare(bCode, undefined, { numeric: true, sensitivity: 'base' });
      return isAsc ? cmp : -cmp;
    },

  },

};
</script>

<style lang="scss">
.disabled-subactivity {
  background: #F8FAFC !important;
  color: #B8C2CA !important;
}

.reduce {
  transform: scale(0.80)
}

.vertical-center {
  vertical-align: inherit !important;
}

/* Se le debería de poder cambiar el icono al botón de details, no probado */
.sub-notifications > td.chevron-cell {
  background-color: #F8E0E0 !important;
}

.sub-notifications > td.chevron-cell svg {
  color: #e3342f !important;
}

.subactivities {
  .table th {
    background-color: #89a4d6;
  }

  &.b-table .table.is-bordered th.is-current-sort, &.b-table .table.is-bordered th.is-sortable:hover {
    background-color: #89a4d6 !important;
  }
}

.table-container {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  overflow-y: hidden;
  max-width: 100%;
}

.row-blue, .row-blue > * {
  background: #c4e3ff !important;
}

.row-orange, .row-orange > * {
  background: #fbd1a7 !important;
}

.row-red, .row-red > * {
  background: #fba7a7 !important;
}

.row-green, .row-green > * {
  background: #a7fbb8 !important;
}

.row-green-dark, .row-green-dark > * {
  background: #68f885 !important;
}

</style>

<style lang="scss" scoped>
.panel::v-deep .b-table .table-wrapper.has-sticky-header tr:first-child th {
  background: hsl(220, 43%, 53%);
}

.hover\:bg-epc-900:hover,
.bg-epc-900 {
  background-color: rgba(56, 93, 165, var(--tw-bg-opacity));
}
@media (min-width: 1024px) {
  .lg\:hover\:bg-epc-50:hover {
    background-color: #5577BB;
  }
}

@media (min-width: 1280px) {
  .xl\:inline {
    display: inline !important;
  }
}

@media (min-width: 640px) {
  .sm\:flex-row {
    flex-direction: row;
  }
}

</style>
